<template>
  <div class="modal fade createNewModal" id="AddModalRegime" tabindex="-1" ref="addRegimeModalRef"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
          <h5 class="modal-title fw-bold text-black">{{ title }}</h5>
        </div>
        <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
          <Form ref="regimeForm" @submit="addRegimeDouanier" :validation-schema="regimeSchema">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Code <span class="text-danger">*</span>
                  </label>
                  <Field name="code" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le code" />
                  <ErrorMessage name="code" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Name <span class="text-danger">*</span>
                  </label>
                  <Field name="name" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le name" />
                  <ErrorMessage name="name" class="text-danger" />
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Description <span class="text-danger">*</span>
                  </label>
                  <Field name="description" as="textarea" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer la description" />
                  <ErrorMessage name="description" class="text-danger" />
                </div>
              </div>
              
              <button
                class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
                type="submit">
                {{ btntext }}
              </button>
            </div>
          </Form>
        </div>
        <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"
          @click="resetValue()"></button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from '../../services/ApiService';
import * as Yup from 'yup';
import { error, success, hideModal } from '../../utils/utils';
import Multiselect from '@vueform/multiselect'
import { RegimeDouanier } from '@/models/RegimeDouanier';

export default defineComponent({
  name: "AddModalRegime",
  components: {
    Form,
    Field,
    ErrorMessage,

  },
  props: {
    item: {
      type: Number,
      default: 0,
    }
  },
  setup(props, { emit }) {
    const regimeSchema = Yup.object().shape({
      code: Yup.string().required('Le code est obligatoire'),
      name: Yup.string().required("Le name ne peut pas etre vide"),
      description: Yup.string().required("La description ne peut pas etre vide"),

    });

    const regimeForm = ref<RegimeDouanier | null>(null);
    const addRegimeModalRef = ref<null | HTMLElement>(null);
    const localItem = ref(props.item);
    const isUPDATE = ref(false);
    const title = ref("Ajouter un régime douanier");
    const btntext = ref('Ajouter');
  


    watch(() => props.item, (newValue) => {
      getRegimeDouanier(newValue);
      isUPDATE.value = true;
      btnTitle();
    });

    const btnTitle = async () => {
      if (isUPDATE.value) {
        title.value = "Modifier un regime douanier";
        btntext.value = "Modifier";
      } else {
        title.value = "Ajouter un regime douanier";
        btntext.value = "Ajouter";
      }
    }

    const getRegimeDouanier = async (id: number) => {
      return ApiService.get("/regime/" + id)
        .then(({ data }) => {
          const donnees = data.data;
          for (const key in donnees) {
            regimeForm.value?.setFieldValue(key,
              (typeof donnees[key] === 'object' && donnees[key] !== null) ? donnees[key].id : donnees[key]
            );
          }
          emit('openmodal', addRegimeModalRef.value);

        })
        .catch(({ response }) => {
          error(response.data.message)
        });
    }

    const addRegimeDouanier = async (values: any, regimeForm) => {
      values = values as RegimeDouanier;

      if (isUPDATE.value) {
        ApiService.put("/regime/" + values.id, values)
          .then(({ data }) => {
            if (data.code == 200) {
              success(data.message);
              regimeForm.resetForm();
              hideModal(addRegimeModalRef.value);
              isUPDATE.value = false;
              btnTitle();
              emit('close');
            }
          })
          .catch(({ response }) => {
            error(response.data.message);
          });
      } else {
        ApiService.post("/regime", values)
          .then(({ data }) => {
            if (data.code == 201) {
              success(data.message);
              regimeForm.resetForm();
              hideModal(addRegimeModalRef.value);
              emit('close');
            }
          })
          .catch(({ response }) => {
            error(response.data.message);
          });
      }
    };
    
    const resetValue = () => {
      const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
      isUPDATE.value = false;
      formFields.forEach(field => {
        field.value = '';
      });
      btnTitle()
    };



    return {
      regimeSchema,
      addRegimeModalRef,
      addRegimeDouanier,
      regimeForm,
      title, btntext, resetValue
    };
  },
});
</script>